/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 9/20/2023
 */

import React, { useState, useEffect, useMemo } from "react"
import { MaterialReactTable, useMaterialReactTable } from "material-react-table"
import { Box, IconButton, Tooltip } from "@mui/material"
import { Edit } from "@mui/icons-material"
import api from "../../services/AuthApi"
import { FetchErrorHandeling } from "../../errorHandeling/FetchErrorHandeling"
import Alerts from "../../errorHandeling/Alerts"
import EditClientSettingsModal from "./EditClientSettingsModal"

const ClientSettings = () => {
  // data and fetching state
  const [appData, setAppData] = useState([])
  const [isloading, setIsLoading] = useState(false)
  const [appRowCount, setAppRowCount] = useState(0)

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  //table state
  const [columnFilters, setColumnFilters] = useState([])
  const [globalFilter, setGlobalFilter] = useState("")
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  //modals state
  const [updateModalOpen, setUpdateModalOpen] = useState(false)
  const [rowData, setRowData] = useState([])

  let reqConfig = {
    headers: {
      "Sort-Order": "DESC",
    },
  }

  const loadClientData = () => {
    setIsLoading(true)
    api
      .get(
        "/clients/" +
          pagination.pageIndex +
          "/" +
          pagination.pageSize +
          "/clientId",
        reqConfig
      )
      .then((res) => {
        setIsLoading(false)
        setAppData(res.data?.dataList)
        setAppRowCount(res.data?.total)

        setErrorMessages([])
        setIserror(false)
      })
      .catch((error) => {
        setIsLoading(false)
        FetchErrorHandeling(error, setIserror, setErrorMessages, setIserrorShow)
      })
  }

  useEffect(() => {
    loadClientData()
  }, [pagination.pageIndex, pagination.pageSize])

  const columns = useMemo(
    () => [
      {
        accessorKey: "clientName",
        header: "Client Name",
      },
      {
        accessorKey: "category",
        header: "Category",
      },
      {
        accessorKey: "accessTokenTimeToLiveInMin",
        header: "Access Token Time",
      },
      {
        accessorKey: "refreshTokenTimeToLiveInMin",
        header: "Refresh Token Time",
      },
      {
        accessorKey: "authorizationCodeTimeToLiveInMin",
        header: "Auth Code Time",
      },
    ],
    []
  )
  return (
    <div>
      <div>
        <Alerts
          iserror={iserror}
          errorMessages={errorMessages}
          iserrorShow={iserrorShow}
        />
      </div>
      <br />
      <MaterialReactTable
        enableColumnVirtualization
        columns={columns}
        data={appData ?? []}
        state={{
          columnFilters,
          globalFilter,
          pagination,
          isloading,
        }}
        getRowId={(row) => row.phoneNumber}
        initialState={{ showColumnFilters: false }}
        manualPagination
        onColumnFiltersChange={setColumnFilters}
        onGlobalFilterChange={setGlobalFilter}
        onPaginationChange={setPagination}
        rowCount={appRowCount}
        muiTablePaginationProps={{
          rowsPerPageOptions: [10],
        }}
        editingMode="modal"
        enableColumnOrdering
        enableGrouping
        enablePinning
        enableRowActions
        enableEditing
        renderRowActions={({ row }) => (
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <Tooltip arrow placement="left" title="Edit">
              <IconButton
                onClick={() => {
                  setUpdateModalOpen(true)
                  setRowData(row.original)
                }}
              >
                <Edit />
              </IconButton>
            </Tooltip>
          </Box>
        )}
      />
      <EditClientSettingsModal
        rowData={rowData}
        open={updateModalOpen}
        onClose={() => {
          setUpdateModalOpen(false)
        }}
      />
    </div>
  )
}

export default ClientSettings
